export const AGE_GROUPS = [
    {key: "U25", value: "< 25", stars: 1},
    {key: "O25U35", value: "25 - 34", stars: 2},
    {key: "O35U45", value: "35 - 44", stars: 3},
    {key: "O45U55", value: "45 - 54", stars: 4},
    {key: "O55U65", value: "55 - 64", stars: 5},
    {key: "O65", value: "> 64", stars: 6}
];

export const DEFAULT_SETUP_DATA = {
    brokerName : "",
    legal : null,
    age : null,
    gender : null,
    country : 'AUS',
    postcode : null,
    state : null,
    phone : null,
    interests : [],
    sophisticatedOrWholesale: false,
    experienceOptions: "NONE"
};
